import { getPropertyLabel } from 'customer-data-property-utils/PropertyDisplay';
import { propertyLabelTranslator } from 'property-translator/propertyTranslator';
const fromProperty = function fromProperty(options) {
  const {
    name,
    type,
    hidden,
    groupName
  } = options;
  return {
    text: getPropertyLabel(options),
    value: name,
    type,
    hidden,
    groupName
  };
};
const fromPropertyGroup = group => ({
  options: group.properties.map(fromProperty),
  text: group.hubspotDefined ? propertyLabelTranslator(group.displayName) : group.displayName,
  value: group.name
});
export const fromPropertyGroups = groups => groups.map(fromPropertyGroup);